import Vue from "vue";
import vuescroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
import app from "@/config/app"; //引入配置文件

Vue.use(vuescroll, app.vuescrollConfig);
